import { mountNavbar } from "../components/navbar";
import { mountReveal } from "../core/reveal";
import { mountSmoothScroll } from "../core/smooth-scroll";
import { mountLeadForms } from "../components/lead-form";
import { mountWordRotator } from "../components/word-rotator";
import { mountCounters } from "../components/counter";
import { mountCookieBanner } from "../components/cookie-banner";
import { mountTicker } from "../components/ticker";
import { mountScrollHint } from "../components/scroll-hint";
import { mountVideoPlayer } from "../components/video_player";
import { mountReactBitsEffects } from "../components/reactbits_effects";
import { mountScrollStack } from "../components/scroll_stack";
import { mountFooterAccordion } from "../components/footer_accordion";

const mountedRoots = new WeakMap();

export function mountHome(root) {
	if (!(root instanceof Element) || mountedRoots.has(root)) return;
	root.querySelector(".solufy-hero__intro .solufy-round-link")?.remove();
	root.querySelectorAll(".solufy-index").forEach((label) => {
		label.textContent = label.textContent.replace(/^\d+\s*\/\s*/, "");
	});

	const cleanups = [
		mountNavbar(root),
		mountReveal(root),
		mountSmoothScroll(root),
		mountLeadForms(root),
		mountWordRotator(root),
		mountCounters(root),
		mountCookieBanner(root),
		mountTicker(root),
		mountScrollHint(root),
		mountVideoPlayer(root),
		mountReactBitsEffects(root),
		mountScrollStack(root),
		mountFooterAccordion(root),
	];

	const scrollParam = new URLSearchParams(window.location.search).get("scroll");
	if (scrollParam) {
		const target = root.querySelector(`#${scrollParam}`) || root.querySelector(`.${scrollParam}`);
		if (target) {
			target.scrollIntoView({ behavior: "instant", block: "start" });
		}
	}

	mountedRoots.set(root, () => {
		cleanups.forEach((cleanup) => cleanup && cleanup());
		mountedRoots.delete(root);
	});
}
